import { MobileDeviceLabels } from "../types";

export const parseDeviceMakeFromDeviceInfo = (
  value: string,
): MobileDeviceLabels => {
  const lowercaseValue = value.toLowerCase();
  if (lowercaseValue.includes("apple") || lowercaseValue.includes("iphone")) {
    return MobileDeviceLabels.iPhone;
  }
  if (lowercaseValue.includes("samsung")) {
    return MobileDeviceLabels.Samsung;
  }
  return MobileDeviceLabels.OtherAndroid;
};

export const parseDeviceMakeFromOemInfo = (
  oem: string,
  os: string,
): MobileDeviceLabels | null => {
  const lowercaseOem = oem.toLowerCase();
  const lowercaseOs = os.toLowerCase();

  if (lowercaseOem.includes("apple") || lowercaseOs.includes("apple")) {
    return MobileDeviceLabels.iPhone;
  }

  if (lowercaseOs.includes("android")) {
    if (lowercaseOem.includes("samsung")) {
      return MobileDeviceLabels.Samsung;
    }
    if (lowercaseOem.includes("google")) {
      return MobileDeviceLabels.Pixel;
    }
    return MobileDeviceLabels.OtherAndroid;
  }

  return null;
}